import axiosService from '../services/axiosService';

const LIST_URL = {
    GET_CART_INFO: '/Cart/GetInfo',
};

const cartApis = {
    getCartInfo: (listProduct) => {
        return axiosService.post(LIST_URL.GET_CART_INFO, listProduct);
    },
};

export default cartApis;
